export default __webpack_public_path__ + "static/media/chatton17.83231b14.webp";